export default __webpack_public_path__ + "static/media/17.1caa0ebf.png";